export const AVATAR_DATA = [
  {
    image:
      'https://res.cloudinary.com/highereducation/image/upload/v1744826004/Supersonic/JO/DCSPromo/asset3.jpg',
    alt: 'DCS Promo',
    title: 'Personalize your search.',
    description:
      "Tell us what you want to study and answer a few questions. We'll sort through all of our schools and programs for you in minutes!",
  },
  {
    image:
      'https://res.cloudinary.com/highereducation/image/upload/v1744826003/Supersonic/JO/DCSPromo/asset2.jpg',
    alt: 'DCS Promo',
    title: 'Explore your matches.',
    description:
      "We'll show you programs currently accepting applications that match your interests. Explore what each one has to offer.",
  },
  {
    image:
      'https://res.cloudinary.com/highereducation/image/upload/v1744826003/Supersonic/JO/DCSPromo/asset1.jpg',
    alt: 'DCS Promo',
    title: 'Find a program you like?',
    description:
      'Submit your info to let the school know you’re interested! A school advisor will reach out soon. You can even start your application!',
  },
];
